<div class="progress-with-percentage">
    <ion-progress-bar [ngStyle]="{'--value': value}" [value]="value" />
    <ion-badge mode="md">
        {{ (value * 100) | localizedNumber }}%
    </ion-badge>
</div>
